import { useEffect, useState } from 'react';
import type { ReactNode } from 'react';
import { RefreshCw } from 'lucide-react';
import { applicaAggiornamento, onUpdateAvailable } from '../pwa/registerSW.js';

/**
 * Avviso di versione nuova.
 *
 * Compare solo quando un aggiornamento e' gia' scaricato e pronto: toccando il
 * pulsante si applica in un istante, senza rete. Prima non c'era, e chi aveva
 * l'app installata restava sulla versione vecchia per sempre — comprese le
 * versioni con un difetto.
 *
 * Non si aggiorna da solo: se stai guardando gli orari del museo mentre ci
 * cammini davanti, l'app non deve ricaricarsi sotto le dita.
 */
export function UpdateBanner(): ReactNode {
  const [disponibile, setDisponibile] = useState(false);

  useEffect(() => {
    return onUpdateAvailable(() => {
      setDisponibile(true);
    });
  }, []);

  if (!disponibile) return null;

  return (
    <div
      role="status"
      className="safe-bottom fixed inset-x-0 bottom-[calc(var(--bottom-nav-height)+8px)] z-50 mx-auto flex max-w-[var(--content-max-width)] items-center justify-between gap-3 rounded-[var(--r-md)] bg-brand-soft px-3 py-2.5 shadow-[var(--shadow-raised)]"
    >
      <p className="text-[14.5px] leading-5 text-brand-strong">
        C’è una versione aggiornata dell’app.
      </p>

      <div className="flex shrink-0 items-center gap-1">
        <button
          type="button"
          onClick={applicaAggiornamento}
          className="flex min-h-[40px] items-center gap-1.5 rounded-[var(--r-sm)] bg-brand-strong px-3 text-[14.5px] font-semibold text-on-brand"
        >
          <RefreshCw size={15} aria-hidden="true" />
          Aggiorna
        </button>
        <button
          type="button"
          onClick={() => {
            setDisponibile(false);
          }}
          aria-label="Rimanda l’aggiornamento"
          className="min-h-[40px] px-2 text-[14.5px] text-text-muted"
        >
          Dopo
        </button>
      </div>
    </div>
  );
}
